module.exports = __webpack_public_path__ + "static/media/mg.6f509455.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mg.svg
// module id = 2152
// module chunks = 0